import { FilterUserUIUseCase } from '@/application/user/filterUserUIUseCase';
import { GetUsersUseCase } from '@/application/user/getUsersUseCase';
import { ProcessUserForTableUseCase } from '@/application/user/processUserForTableUseCase';
import { ResetPasswordUserUseCase } from '@/application/user/resetPasswordUserUseCase';
import { UpdateUserRoleUseCase } from '@/application/user/updateUserRoleUseCase';
import { userApiRepository } from '@/infra/repositories/userApi.repository';

let _getUsersUseCase: GetUsersUseCase | null = null;
let _updateUserRoleUseCase: UpdateUserRoleUseCase | null = null;
let _processUserForTableUseCase: ProcessUserForTableUseCase | null = null;
let _filterUserUIUseCase: FilterUserUIUseCase | null = null;
let _resetPasswordUserUseCase: ResetPasswordUserUseCase | null = null;

export const getUsersUseCase = (): GetUsersUseCase => {
  if (!_getUsersUseCase) {
    _getUsersUseCase = new GetUsersUseCase(userApiRepository);
  }
  return _getUsersUseCase;
};

export const updateUserRoleUseCase = (): UpdateUserRoleUseCase => {
  if (!_updateUserRoleUseCase) {
    _updateUserRoleUseCase = new UpdateUserRoleUseCase(userApiRepository);
  }
  return _updateUserRoleUseCase;
};

export const processUserForTableUseCase = (): ProcessUserForTableUseCase => {
  if (!_processUserForTableUseCase) {
    _processUserForTableUseCase = new ProcessUserForTableUseCase();
  }

  return _processUserForTableUseCase;
};

export const filterUserUIUseCase = (): FilterUserUIUseCase => {
  if (!_filterUserUIUseCase) {
    _filterUserUIUseCase = new FilterUserUIUseCase();
  }
  return _filterUserUIUseCase;
};

export const resetPasswordUserUseCase = (): ResetPasswordUserUseCase => {
  if (!_resetPasswordUserUseCase) {
    _resetPasswordUserUseCase = new ResetPasswordUserUseCase(userApiRepository);
  }
  return _resetPasswordUserUseCase;
};

export const resetUserContainer = (): void => {
  _getUsersUseCase = null;
  _updateUserRoleUseCase = null;
  _processUserForTableUseCase = null;
  _filterUserUIUseCase = null;
  _resetPasswordUserUseCase = null;
};
